<script setup>
const { activeRole } = useRolePermissions()
const { t } = useI18n()

const roleLabel = computed(() => {
  if (!activeRole.value) return ''
  return t(`roles.${activeRole.value}`)
})
</script>

<template>
  <div v-if="activeRole" class="text-xs text-slate-500">
    Actuando como: <span class="font-medium text-slate-700">{{ roleLabel }}</span>
  </div>
</template>
